import {
    AbstractController
} from "../../abstract/AbstractController";
import { StakeUpdateService, StakeHistoryService, StakeService, BalanceService, UnstakeService, AccountService, ClaimService, AccountLevelUpdateService, AutoStakeUpdateService, RestakeService, PoolBalanceService, APRService, RewardPoolBalanceService } from "./StakeService";
  

export interface StakeControllerParams { }

interface Children {
    processButton: HTMLElement | null;
    amountInputField: HTMLElement | null;
    resetButton: HTMLElement | null;
  }

export class StakeController extends AbstractController { 

    public balanceService = new BalanceService();
    public stakeUpdateService = new StakeUpdateService();
    public unstakeService = new UnstakeService();
    public stakeService = new StakeService();
    public stakeHistoryService = new StakeHistoryService();
    public accountService = new AccountService();
    public claimService = new ClaimService();
    public accountLevelUpdateService = new AccountLevelUpdateService();
    public autoStakeUpdateService = new AutoStakeUpdateService();
    public restakeService = new RestakeService();
    public poolBalanceService = new PoolBalanceService();
    public aprService = new APRService();
    public rewardPoolBalanceService = new RewardPoolBalanceService();

    constructor(
        public rootNode: HTMLElement | null,
        public params: StakeControllerParams,
        public children: Children
      ) {
        super(rootNode);
        if (!rootNode) throw new Error("No root node");
        
    }

}